var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"offset-xxl-1 col-xxl-10"},[_c('MixedWidget1')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }